export default __webpack_public_path__ + "static/better-care-f28d7bb5395fd4d476b731b8a28f3c59.mp4";